import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
@Component({
  selector: 'app-sanction-letter-component',
  templateUrl: './sanction-letter-component.component.html',
  styleUrls: ['./sanction-letter-component.component.scss']
})
export class SanctionLetterComponentComponent implements OnInit {
  public filteredAppId: any;
  public farmerMobile: string;
  public farmerId: any;
  public farmerAppDetails: any;
  public selectedAppId: any;
  public selectedFarmerDeatils: any;
  public famerAppDetailsforDropDown: any = [];
  
  constructor(
    public router: Router,
    public dashboard: DashboardService,
    public productService: BankDetailService, 
    public challanMIService: ChallanService,
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService
  ) { }
  ngOnInit(): void {
    this.farmerMobile = sessionStorage.getItem('farmerPh');
    console.log("farmerId",sessionStorage.getItem('farmerId'))
    this.getApplicationIdsForChallan(sessionStorage.getItem('farmerId'))
  }
  getApplicationIdsForChallan(farmerId) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    this.loader.start();
    this.challanMIService
      .getApplicationIdsForChallan(farmerId,'SanctionLetter')
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.activityRecordService.activityRecord(mobile, 'MI Challan', farmerId, new Date(), 'Success');
     
          this.farmerAppDetails = res;
          this.loader.close();
          console.log("farmerAppDetails", this.farmerAppDetails);
          // this.farmerAppDetails.map(val => {
          //   this.famerAppDetailsforDropDown.push({ 
          //     AppId: val.AppId.concat(" (" ,val.ProgramId, ")"),
          //     ProgramId: val.ProgramId,
          //     ChallanStatus: val.ChallanStatus
          //   })
          // })
          if (this.farmerAppDetails.length > 0) {
            this.famerAppDetailsforDropDown = this.farmerAppDetails.map(res => {
              return {
                appIdToDisplay: res.AppId + ' ('+ res.ProgrammeName + ')',
              ...res
             }
            })
          }
          console.log("famerAppDetailsforDropDown", this.famerAppDetailsforDropDown);
        },
        error: (err) => {
          this.activityRecordService.activityRecord(mobile, 'MI Challan', farmerId, new Date(), err);
          this.loader.close();
          console.log("error", err);  
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onFarmerShareClick(){
    this.router.navigate([`challan/farmer-share/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onFullPaymentClick(){
    this.router.navigate([`challan/full-payment/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onSanctionLetterClick(){
    this.router.navigate([`sanction/sanction-letter/${this.selectedAppId.AppId}/${this.selectedAppId.ProgID}`]);
  }

  onSelectAppId(){
    console.log("selected farmer details", this.selectedFarmerDeatils);
    this.selectedAppId = this.selectedFarmerDeatils;
    console.log("selected app ID", this.selectedAppId.AppId);
  }
}
